import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/profile/")({
  beforeLoad: () => {
    throw redirect({ to: "/settings" });
  },
  component: () => null,
  staticData: { authorize: true, requiresAccount: false },
});
